import { useEffect } from "react";

// Microsoft Clarity project id
const CLARITY_PROJECT_ID = "yxhvud4l3e";

/**
 * Loads the Microsoft Clarity tag once.
 * It is rendered only by the pages that should be tracked (currently the home
 * page), so all the other routes stay untouched.
 *
 * Same logic as the snippet Microsoft generates, except that the tag falls
 * back to <head> when the document has no <script> yet.
 */
const ClarityAnalytics = () => {
    useEffect(() => {
        if (document.querySelector('script[src*="clarity.ms/tag/"]')) {
            return;
        }

        // queue the calls that happen before https://www.clarity.ms/tag/... loads
        window.clarity = window.clarity || function () {
            (window.clarity.q = window.clarity.q || []).push(arguments);
        };

        const tag = document.createElement("script");
        tag.async = true;
        tag.src = "https://www.clarity.ms/tag/" + CLARITY_PROJECT_ID;

        const firstScript = document.getElementsByTagName("script")[0];
        if (firstScript && firstScript.parentNode) {
            firstScript.parentNode.insertBefore(tag, firstScript);
        } else {
            document.head.appendChild(tag);
        }
    }, []);

    return null;
};

export default ClarityAnalytics;
